export default "__VITE_ASSET__DFSG9q82__"